import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useParams } from 'react-router-dom';
import {
    ArrowLeft, Save, FileText, ChevronDown, ChevronUp, Trash2, Printer, X,
    Truck, Package, User, Ship, MapPin,
    Calendar, Plus, ClipboardCheck, Eye,
    Weight
} from 'lucide-react';
import { toast } from 'sonner';
import { SearchBar } from '@/components/SearchBox/SearchBar';
import { getAddressAPI } from '@/redux/Purchase/actions';
import { SearchBarPagination } from '@/components/SearchBox/SearchBarPagination';
import { useDispatch, useSelector } from 'react-redux';
import { showToast } from '@/redux/Toast/actions';
import { callLoader } from '@/redux/Loader/actions';
import { getDeliveryOrderDetails, updateDeliveryOrderDetails } from '@/redux/ImportBooking/actions';
import DateTimeInputwithcal from '@/components/ui/DateTimeInputwithcal';
import DateInputwithcal from '@/components/ui/DateInputwithcal';
import { getClauselist } from '@/redux/Common/actions';
import { validateForm } from '@/components/ui/useFormValidation';
import DeliveryOrderValidation from "@/validation/deliveryOrderform.json"
import { Button } from '@/components/ui/button';
import PageHeader from '@/components/FormHeader/formPageHeader';
import CelebrationButton from '@/components/ui/CelebrationButton/CelebrationButton';

const DeliveryOrderForm = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const dispatch = useDispatch();
    const { officeTypeList, containerTypeList } = useSelector((state) => state.common);
    const { isAnimate } = useSelector((state) => state.toast);


    const isEditMode = !!id && id !== 'new';

    const [authUser] = JSON.parse(localStorage.getItem('authUser') ?? "[{}]");

    console.log("authUser in delivery order form", authUser?.companyId)


    const [formData, setFormData] = useState({
        ID: 0,
        BolID: 0,
        Company_Id: 0,

        DeliveryOrderNumber: "",
        DeliveryDate: null,

        MAWBNumber: "",
        HAWBNumber: "",
        EntryNo: "",
        OurRefNo: "",

        Payment_Mode: "",

        DeliveryToId: 0,
        DeliveryTo: "",
        DeliveryToAddress: "",

        TruckerID: 0,
        Trucker: "",
        TruckerAddress: "",
        TruckerContactPerson: "",

        OriginFromCode: "",
        OriginFrom: "",

        LoadPortCode: "",
        LoadPort: "",

        DestinationToCode: "",
        DestinationTo: "",

        ArrivalDate: null,

        CustRefNo: "",
        FreeTimeExp: "",

        CarrierID: 0,
        CarrierName: "",
        CarrierScac: "",

        FreightLocationID: 0,
        FreightLocation: "",
        FreightLocationAddress: "",

        DeliveryInstructions: "",
        RouteDetails: "",

        CargoDescription: "",

        WeightPrintOption: "",   // "M" / "E" / "B"
        SLAC: false,
        DoNotAutoCalculate: false,

        TotalContainer: 0,
        TotalPackage: 0,
        TotalKgs: "",
        TotalLbs: "",
        TotalCbm: "",
        TotalCft: "",

        FirmsCode: "",
        OfficeType: "",

        ITNumber: "",
        ITPlace: "",
        ITDate: null,

        LastFreeDate: null,

        CPRSNumber: "",

        BillToPartyID: 0,
        BillToParty: "",
        BillToPatyAddress: "",

        totalNetLbs: 0,
        totalNetKgs: 0,

        IsAccepted_WO: false,
        IsAccepted_WO_On: null,
        IsAccepted_WO_By: "",
        IsAccepted_WO_Remarks: "",

        IsRejected_WO: false,
        IsRejected_WO_On: null,
        IsRejected_WO_By: "",
        IsRejected_WO_Remarks: "",

        CreatedBy: "",
        CreatedOn: null,
        ModifiedBy: "",
        ModifiedOn: null,

        IsActive: true,
        IsDeleted: false
    });

    const [containers, setContainers] = useState([
        {
            ID: 0,
            ContainerNumber: "",
            SealNumber: "",
            MarksNo: "",
            ContTypeCode: "",
            ContTypeName: "",
            NoPackage: 0,
            PackageCode: "",
            PackageDescription: "",
            ScheduleB: "",
            HAZCode: "",
            Manufacturer: "",
            Country: "",
            CargoDescription: "",
            KGS: 0,
            LBS: 0,
            CBM: 0,
            CFT: 0,
            ITNumber: "",
            CNCPRSNumber: "",
            PickUpNumber: "",
            LastDate: null,
            NetLbs: 0,
            NetKgs: 0,
            ContainerParentID: 0,
            IsDeleted: false
        }
    ]);
    const [clauses, setClauses] = useState([]);


    const [errors, setErrors] = useState({});
    const [dateErrors, setDateErrors] = useState({});
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [loadError, setLoadError] = useState(false);



    const [expandedSections, setExpandedSections] = useState({
        fileInfo: true,
        particulars: true,
        commonClause: true
    });

    const toggleSection = (section) => {
        setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
    };

    const handleInputChange = (e) => {
        if (!e?.target) {
            setFormData(prev => ({ ...prev, ...e }));
            return;
        }

        const { name, value, type, checked } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleContainerChange = (index, field, value) => {
        setContainers(prev => prev.map((c, i) => i === index ? { ...c, [field]: value } : c));
    };

    const addContainer = () => {
        setContainers(prev => [
            ...prev,
            {
                ID: 0,
                tempId: Date.now(),
                ContainerNumber: "",
                SealNumber: "",
                MarksNo: "",
                ContTypeCode: "",
                ContTypeName: "",
                NoPackage: 0,
                PackageCode: "",
                PackageDescription: "",
                ScheduleB: "",
                HAZCode: "",
                Manufacturer: "",
                Country: "",
                CargoDescription: "",
                KGS: 0,
                LBS: 0,
                CBM: 0,
                CFT: 0,
                ITNumber: "",
                CNCPRSNumber: "",
                PickUpNumber: "",
                LastDate: null,
                NetLbs: 0,
                NetKgs: 0,
                ContainerParentID: 0,
                IsDeleted: false
            }
        ]);
    };

    const removeContainer = (itemToRemove) => {
        setContainers(prev =>
            prev.map(item =>
                (item.ID > 0 && item.ID === itemToRemove.ID) ||
                    (item.ID === 0 && item.tempId === itemToRemove.tempId)
                    ? { ...item, IsDeleted: true }
                    : item
            )
        );
    };

    const handleSubmit = async (e) => {
        e?.preventDefault?.();

        console.log("handleSubmit form", formData);

        // ✅ Prevent submit if edit data failed to load
        if (isEditMode && (!isDataLoaded || loadError)) {
            dispatch(
                showToast(
                    "Delivery Order data not loaded properly",
                    "error"
                )
            );
            return;
        }

        // ✅ Form validation
        const validationErrors = validateForm({
            data: formData,
            rules: DeliveryOrderValidation,
        });

        setErrors(validationErrors);

        // ✅ Date validation
        const hasDateErrors = Object.values(
            dateErrors || {}
        ).some(Boolean);

        // ✅ Stop submit on validation errors
        if (
            Object.keys(validationErrors).length > 0 ||
            hasDateErrors
        ) {
            return;
        }

        try {
            dispatch(callLoader(1));

            console.log("containers", containers);

            const clausesPayload =
                prepareClausesForAPI();

            console.log(
                "ArrivalDeliveryOrderClause",
                clausesPayload
            );

            // ✅ Final payload
            const payload = {
                ...formData,
                ID: formData?.ID || 0,
                BolID: formData?.BolID || 0,

                ArrivalDeliveryOrderContainers:
                    Array.isArray(containers)
                        ? containers
                        : [],

                ArrivalDeliveryOrderClauses:
                    Array.isArray(clausesPayload)
                        ? clausesPayload
                        : [],
            };

            console.log("payload api", payload);

            // ✅ API call
            const response = await dispatch(
                updateDeliveryOrderDetails(payload)
            );

            console.log("API RESPONSE", response);

            // ✅ Success validation
            const isSuccess = [200, 201].includes(
                response?.statuscode
            );

            if (!isSuccess) {
                throw new Error(
                    response?.message ||
                    "Error while saving Delivery Order"
                );
            }

            // ✅ Success toast
            dispatch(
                showToast(
                    isEditMode
                        ? "Delivery Order updated successfully!"
                        : "Delivery Order created successfully!",
                    "success",
                    true
                )
            );

            // navigate('/import-booking');

            return {
                success: true,
                status: response.statuscode,
                data: response,
            };

        } catch (error) {
            console.error(
                "SUBMIT DELIVERY ORDER ERROR:",
                error
            );

            const errorMessage =
                error?.response?.data?.title ||
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong";

            dispatch(
                showToast(errorMessage, "error")
            );

            return {
                success: false,
                status:
                    error?.response?.status ||
                    error?.statuscode ||
                    500,
                errors:
                    error?.response?.data?.errors || null,
            };

        } finally {
            dispatch(callLoader(0));
        }
    };
    const handleDateChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value ? value : null, // store null if blank
        }));
    };


    const handleDateError = (fieldName, hasError) => {
        setDateErrors(prev => ({
            ...prev,
            [fieldName]: hasError
        }));
    };


    const _setAddress = async (type, id) => {
        console.log(type, id, "type, id")
        const address = await getAddressAPI(id);
        console.log("address", address)
        setFormData(prev => ({ ...prev, [`${type}`]: address }));
    };

    const totals = containers.reduce((acc, c) => {
        if (c.ContainerNumber) acc.totalContainers += 1;

        acc.totalPackages += c.NoPackage ?? 0;
        acc.totalNetWeightKgs += c.NetKgs ?? 0;
        acc.totalNetWeightLbs += c.NetLbs ?? 0;
        acc.totalGrossKgs += c.KGS ?? 0;
        acc.totalGrossLbs += c.LBS ?? 0;
        acc.totalCbm += c.CBM ?? 0;
        acc.totalCft += c.CFT ?? 0;

        return acc;
    }, {
        totalContainers: 0,
        totalPackages: 0,
        totalNetWeightKgs: 0,
        totalNetWeightLbs: 0,
        totalGrossKgs: 0,
        totalGrossLbs: 0,
        totalCbm: 0,
        totalCft: 0
    });

    const inputClass = "w-full px-3 py-[0.6rem] bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md text-sm text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all";
    const selectClass = "w-full px-3 py-[0.5rem] bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md text-sm text-slate-900 dark:text-white focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all appearance-none cursor-pointer";
    const labelClass = "block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1";


    const SectionHeader = ({ icon: Icon, title, color = "blue", section }) => (
        <button
            onClick={() => toggleSection(section)}
            className="w-full flex items-center justify-between p-4 bg-gradient-to-r from-white to-slate-100 dark:from-slate-800 dark:to-slate-700 cursor-pointer"
        >
            <div className="flex items-center gap-3">
                <div className={`p-2 rounded-lg shadow-md ${color}`}>
                    <Icon className="w-4 h-4 text-white" />
                </div>
                <h2 className="text-sm font-semibold text-slate-900 dark:text-slate-200">{title}</h2>
            </div>
            <div className={`p-1.5 rounded-md transition-colors ${expandedSections[section] ? "bg-indigo-100 dark:bg-indigo-900/30"
                : "bg-slate-200 dark:bg-slate-700"}`}>
                {expandedSections[section] ? (
                    <ChevronUp className="w-4 h-4 text-indigo-600 dark:text-indigo-400" />
                ) : (
                    <ChevronDown className="w-4 h-4 text-slate-500 dark:text-slate-400" />
                )}
            </div>
        </button>
    );

    // { start common clauses handlers}
    const syncClausesWithFormData = (apiClauses, formClauses) => {
        if (!apiClauses?.length) return apiClauses;

        return apiClauses.map(apiClause => {
            const existing = formClauses?.find(
                f => f.ClauseTypeDescID == apiClause.ClauseTypeDescriptionID
            );

            return {
                ...apiClause,
                applied: existing ? existing.IsActive : false,
                originalData: existing || null   // 🔥 keep full API record
            };
        });
    };
    const getClauselistData = async (formClauses = []) => {
        try {
            const payload = {
                IPageNo: 1,
                IPageRecords: 1000,
                Type: 3
            };

            const clauseData = await dispatch(getClauselist(payload));

            const transformedData = clauseData.map(item => ({
                ClauseTypeDescriptionID: item.ClauseTypeDescriptionID,
                ClauseType: item.ClauseType,
                ClauseDescription: item.ClauseDescription
            }));

            const syncedClauses = syncClausesWithFormData(
                transformedData,
                formClauses
            );

            setClauses(syncedClauses);

        } catch (error) {
            console.error('Error loading clauses:', error);
        }
    };
    const handleClauseChange = (clauseId, field, value) => {
        if (field === 'applied') {
            setClauses(prev =>
                prev.map(clause =>
                    clause.ClauseTypeDescriptionID === clauseId
                        ? {
                            ...clause,
                            applied: typeof value === 'boolean'
                                ? value
                                : !clause.applied
                        }
                        : clause
                )
            );
        }
    };
    const prepareClausesForAPI = () => {
        const result = [];
        const now = new Date().toISOString();

        clauses?.forEach(clause => {
            const existing = clause.originalData;

            if (existing) {
                // ✅ EXISTING → UPDATE
                result.push({
                    ...existing,
                    IsActive: clause.applied,
                    ModifiedBy: authUser?.username || "system",
                    ModifiedOn: now
                });
            } else if (clause.applied) {
                // 🆕 NEW → INSERT
                result.push({
                    ID: 0,
                    BolID: formData?.BolID || 0,
                    Company_Id: formData?.Company_Id || authUser?.companyId || 0,
                    DeliveryOrderID: formData?.ID || 0,
                    ClauseTypeDescID: clause.ClauseTypeDescriptionID,
                    CreatedBy: authUser?.username || "system",
                    CreatedOn: now,
                    ModifiedBy: "",
                    ModifiedOn: null,
                    IsActive: true
                });
            }
        });

        return result;
    };

    const _getDeliveryOrderData = async () => {
        try {
            dispatch(callLoader(1));


            setIsDataLoaded(false);
            setLoadError(false);

            const resultData = await dispatch(
                getDeliveryOrderDetails(
                    id,
                    authUser?.companyId
                )
            );

            console.log(
                "delivery order data api",
                resultData
            );

            if (
                !resultData ||
                typeof resultData !== "object"
            ) {
                throw new Error(
                    "Invalid Delivery Order data"
                );
            }

            const {
                ArrivalDeliveryOrderContainers = [],
                ArrivalDeliveryOrderClauses = [],
                ...lightData
            } = resultData;

            setFormData(prev => ({
                ...prev,
                ...lightData
            }));

            // ✅ Update containers safely
            setContainers(
                Array.isArray(
                    ArrivalDeliveryOrderContainers
                )
                    ? ArrivalDeliveryOrderContainers
                    : []
            );

            getClauselistData(
                Array.isArray(
                    ArrivalDeliveryOrderClauses
                )
                    ? ArrivalDeliveryOrderClauses
                    : []
            );

            setIsDataLoaded(true);

        } catch (error) {
            console.error(
                "GET DELIVERY ORDER ERROR:",
                error
            );

            setLoadError(true);

            dispatch(
                showToast(
                    error?.message ||
                    "Failed to load Delivery Order details",
                    "error"
                )
            );
        } finally {
            dispatch(callLoader(0));
        }
    };

    useEffect(() => {
        if (!id || id === "new") return;

        _getDeliveryOrderData();

        setFormData((prev) => ({
            ...prev,
            BolID: prev?.BolID && prev.BolID !== 0 ? prev.BolID : id,
            Company_Id:
                prev?.Company_Id && prev.Company_Id !== 0
                    ? prev.Company_Id
                    : authUser?.companyId || 0,
            ModifiedBy: authUser?.username ?? "system",
            ModifiedOn: new Date().toISOString(),
        }));
    }, [id]);

    return (

        <div className="mx-auto p-2 sm:p-3 sticky top-0 bg-gradient-to-r">            {/* Header */}
            <PageHeader
                icon={<Truck className="w-5 h-5 text-white" />}

                title="Delivery Order"

                badge={
                    formData?.HAWBNumber
                        ? `HBL: ${formData.HAWBNumber}`
                        : isEditMode
                            ? "Editing Delivery Order"
                            : "New Delivery Order"
                }

                subtitle={
                    isEditMode
                        ? "Update delivery order details"
                        : "Create a new delivery order"
                }

                actions={[
                    {
                        label: "Back",
                        icon: <ArrowLeft />,
                        onClick: () => navigate("/import-booking"),
                        variant: "ghost",
                    },

                    "|",

                    {
                        label: "BL",
                        onClick: () => navigate(`/import-booking/edit/${formData?.BolID || id}`),
                        variant: "tertiary",
                    },
                    {
                        label: "Status Audit",
                        onClick: () => navigate(`/import-booking/status-audit/${formData?.BolID || 0}?companyId=${authUser?.companyId}`, {
                            state: {
                                bookingId: formData?.BolID || id || 0,
                                companyId: authUser?.companyId,
                            }
                        }),
                        variant: "tertiary",
                    },
                    {
                        label: "New Delivery Order",
                        onClick: () => navigate("/delivery-order/new"),
                        variant: "tertiary",
                    },

                    "|",
                    {
                        label: "Print",
                        icon: <Printer />,
                        onClick: () =>
                            window.open(
                                `/delivery-order/print/${btoa(String(formData?.BolID ?? ""))}`
                            ),
                        variant: "black",
                    },
                ]}
                submitLabel="Save"
                onSubmit={handleSubmit}
            />
            <div style={{ height: "var(--page-header-height)" }} />


            <form className="space-y-3" onSubmit={(e) => e.preventDefault()}>
                {/* File Information */}
                <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-700/30 dark:border-slate-700 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <SectionHeader icon={FileText} title="File Information" color="bg-cyan-500" section="fileInfo" />

                    {expandedSections.fileInfo && (
                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: 'auto', opacity: 1 }}
                            className="p-4 border-t border-slate-200 dark:border-slate-800"
                        >
                            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                                {/* Left Column */}
                                <div className="space-y-3">
                                    <div className="grid grid-cols-1 sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            Date <span className="text-red-500">*</span>
                                        </label>
                                        <div>
                                            <DateInputwithcal onError={handleDateError} label="Date" name="DeliveryDate" value={formData?.DeliveryDate} onChange={handleDateChange} required />
                                            {errors.DeliveryDate && (
                                                <p className="text-red-500 text-xs mt-1">{errors.DeliveryDate}</p>
                                            )}
                                        </div>                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            MBL / AWB No.
                                        </label>
                                        <input type="text" name="MAWBNumber" value={formData.MAWBNumber} onChange={handleInputChange} className={inputClass} data-testid="field-master-bl" />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">

                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            HAWB No. <span className="text-red-500">*</span>
                                        </label>
                                        <input type="text" name="HAWBNumber" value={formData.HAWBNumber} onChange={handleInputChange} className={inputClass} data-testid="field-master-bl" />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">

                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            Entry No.
                                        </label>
                                        <input type="text" name="EntryNo" value={formData.EntryNo} onChange={handleInputChange} className={inputClass} data-testid="field-house-bl" />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">

                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">File Ref No.</label>
                                        <input type="text" name="OurRefNo" value={formData.OurRefNo} onChange={handleInputChange} className={inputClass} data-testid="field-sub-bl" />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">

                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Payment Mode</label>

                                        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-6">
                                            {[
                                                { value: "P", label: "Prepaid", color: "emerald" },
                                                { value: "C", label: "Collect", color: "blue" },
                                                { value: "N", label: "No Status", color: "gray" }
                                            ].map((option) => (
                                                <label key={option.value} className="flex items-center gap-2 text-sm cursor-pointer group">
                                                    <input
                                                        type="radio"
                                                        name="Payment_Mode"
                                                        value={option.value}
                                                        checked={formData?.Payment_Mode === option.value}
                                                        onChange={() => handleInputChange({ target: { name: "Payment_Mode", value: option.value } })}
                                                        className={`w-4 h-4 accent-${option.color}-600`}
                                                    />
                                                    <span className="text-slate-700 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-white transition-colors">
                                                        {option.label}
                                                    </span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-semibold text-emerald-600 dark:text-emerald-400 mb-1 block">
                                            Delivery To
                                        </label>
                                        {/* <input type="text" name="releaseTo" value={formData?.releaseTo} onChange={handleInputChange} className={inputClass} data-testid="field-release-to" /> */}
                                        <SearchBar
                                            searchAPI={'v1/AutoSuggestion/GetDestinationSuggestion?Prefix='}
                                            selectReacord={(d) => {
                                                handleInputChange({ target: { name: 'DeliveryTo', value: d?.[1] } })
                                                handleInputChange({ target: { name: 'DeliveryToId', value: d?.[0] } })
                                                _setAddress('DeliveryToAddress', d?.[0]);
                                            }}
                                            value={formData?.DeliveryTo}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({ target: { name: 'DeliveryTo', value: '' } });
                                                    handleInputChange({ target: { name: 'DeliveryToId', value: 0 } });
                                                    handleInputChange({ target: { name: 'DeliveryToAddress', value: '' } });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-semibold text-red-500 mb-1 block">Address</label>
                                        <textarea name="DeliveryToAddress" value={formData?.DeliveryToAddress} onChange={handleInputChange} rows={3} className={`${inputClass} resize-none`} data-testid="field-deliver-to-address" />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Contact Person (Trucker)</label>
                                        <input type="text" name="TruckerContactPerson" value={formData.TruckerContactPerson} onChange={handleInputChange} className={inputClass} data-testid="field-sub-bl" />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-semibold text-emerald-600 dark:text-emerald-400 mb-1 block">
                                            Trucker
                                        </label>
                                        {/* <input type="text" name="releaseTo" value={formData?.releaseTo} onChange={handleInputChange} className={inputClass} data-testid="field-release-to" /> */}
                                        <SearchBar
                                            searchAPI={'v1/AutoSuggestion/GetTruckerAndTowing?Prefix='}
                                            selectReacord={(d) => {
                                                handleInputChange({ target: { name: 'Trucker', value: d?.[1] } })
                                                handleInputChange({ target: { name: 'TruckerID', value: d?.[0] } })
                                                _setAddress('TruckerAddress', d?.[0]);
                                            }}
                                            value={formData?.Trucker}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({ target: { name: 'Trucker', value: '' } });
                                                    handleInputChange({ target: { name: 'TruckerID', value: 0 } });
                                                    handleInputChange({ target: { name: 'TruckerAddress', value: '' } });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-semibold text-red-500 mb-1 block">Address</label>
                                        <textarea name="TruckerAddress" value={formData?.TruckerAddress} onChange={handleInputChange} rows={3} className={`${inputClass} resize-none`} data-testid="field-release-to-address" />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-semibold text-emerald-600 dark:text-emerald-400 mb-1 block">
                                            Bill to Party
                                        </label>
                                        {/* <input type="text" name="releaseTo" value={formData?.releaseTo} onChange={handleInputChange} className={inputClass} data-testid="field-release-to" /> */}
                                        <SearchBar
                                            searchAPI={'v1/AutoSuggestion/GetBilltoPartyList?Prefix='}
                                            selectReacord={(d) => {
                                                handleInputChange({ target: { name: 'BillToParty', value: d?.[1] } });
                                                handleInputChange({ target: { name: 'BillToPartyID', value: d?.[0] } });
                                                _setAddress('BillToPatyAddress', d?.[0]);
                                            }}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({ target: { name: 'BillToParty', value: '' } });
                                                    handleInputChange({ target: { name: 'BillToPartyID', value: 0 } });
                                                    handleInputChange({ target: { name: 'BillToPatyAddress', value: '' } });
                                                }
                                            }}
                                            value={formData?.BillToParty || ''}
                                        />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label />
                                        <textarea name="BillToPatyAddress" value={formData?.BillToPatyAddress} onChange={handleInputChange} rows={3} className={`${inputClass} mt-2`} placeholder="Address (include phone, email)" />                                    </div>
                                </div>

                                {/* Right Column */}
                                <div className="space-y-3 ">
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className={labelClass}>Office Type</label>
                                        <select name="OfficeType" value={formData?.OfficeType} onChange={handleInputChange} className={selectClass}>
                                            <option value="">Select Office</option>
                                            {
                                                officeTypeList?.map((item, index) => (
                                                    <option key={index} value={item.officeCode}>{item.officeType}</option>
                                                ))
                                            }
                                        </select>

                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Origin From</label>
                                        <SearchBar
                                            searchAPI={'v1/AutoSuggestion/GetDestinationSuggestion?Prefix='}
                                            selectReacord={(d) => {
                                                handleInputChange({ target: { name: 'OriginFrom', value: d?.[1] } })
                                                handleInputChange({ target: { name: 'OriginFromCode', value: d?.[1]?.match(/\[(.*?)\]/)?.[1] || '' } })
                                            }}
                                            value={formData?.OriginFrom}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({ target: { name: 'OriginFrom', value: '' } });
                                                    handleInputChange({ target: { name: 'OriginFromCode', value: '' } });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Load Port <span className="text-red-500">*</span></label>
                                        <SearchBar
                                            searchAPI={'v1/AutoSuggestion/GetDestinationSuggestion?Prefix='}
                                            selectReacord={(d) => {
                                                handleInputChange({ target: { name: 'LoadPort', value: d?.[1] } })
                                                handleInputChange({ target: { name: 'LoadPortCode', value: d?.[1]?.match(/\[(.*?)\]/)?.[1] || '' } })
                                            }}
                                            value={formData?.LoadPort}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({ target: { name: 'LoadPort', value: '' } });
                                                    handleInputChange({ target: { name: 'LoadPortCode', value: '' } });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Destination To <span className="text-red-500">*</span></label>
                                        <SearchBar
                                            searchAPI={'v1/AutoSuggestion/GetDestinationSuggestion?Prefix='}
                                            selectReacord={(d) => {
                                                handleInputChange({ target: { name: 'DestinationTo', value: d?.[1] } })
                                                handleInputChange({ target: { name: 'DestinationToCode', value: d?.[1]?.match(/\[(.*?)\]/)?.[1] || '' } })
                                            }}
                                            value={formData?.DestinationTo}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({ target: { name: 'DestinationTo', value: '' } });
                                                    handleInputChange({ target: { name: 'DestinationToCode', value: '' } });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Arrival Date</label>
                                        <div>
                                            <DateInputwithcal onError={handleDateError} label="Date" name="ArrivalDate" value={formData?.ArrivalDate} onChange={handleDateChange} required />
                                            {errors.ArrivalDate && (
                                                <p className="text-red-500 text-xs mt-1">{errors.ArrivalDate}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Cust Ref No</label>
                                        <input type="text" name="CustRefNo" value={formData.CustRefNo} onChange={handleInputChange} className={inputClass} data-testid="field-it-number" />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className={labelClass}>Importing Carrier<span className="text-red-500">*</span></label>
                                        <div>
                                            <SearchBarPagination
                                                searchAPI="v1/AutoSuggestion/GetCarrierSuggestion?Prefix="
                                                selectReacord={(d) => {
                                                    handleInputChange({
                                                        target: { name: 'CarrierID', value: d?.[0] || null },
                                                    });
                                                    handleInputChange({
                                                        target: { name: 'CarrierName', value: d?.[1] || "" },
                                                    });
                                                    handleInputChange({
                                                        target: { name: 'CarrierScac', value: d?.[2] || "" },
                                                    });
                                                }}
                                                value={formData?.CarrierName || ''}
                                                placeholder="Select carrier"
                                                className="bg-white dark:bg-slate-900 border border-slate-700 rounded-lg text-sm text-white"
                                            />

                                            {errors.CarrierID && (
                                                <p className="text-red-500 text-xs mt-1">{errors.CarrierID}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-semibold text-emerald-600 dark:text-emerald-400 mb-1 block">
                                            Freight Location
                                        </label>
                                        <SearchBar
                                            searchAPI={'v1/AutoSuggestion/GetDestinationSuggestion?Prefix='}
                                            selectReacord={(d) => {
                                                handleInputChange({ target: { name: 'FreightLocation', value: d?.[1] } })
                                                handleInputChange({ target: { name: 'FreightLocationID', value: d?.[0] } })
                                                _setAddress('FreightLocationAddress', d?.[0]);

                                            }}
                                            value={formData?.FreightLocation}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({ target: { name: 'FreightLocation', value: '' } });
                                                    handleInputChange({ target: { name: 'FreightLocationID', value: 0 } });
                                                    handleInputChange({ target: { name: 'FreightLocationAddress', value: '' } });
                                                }
                                            }}
                                        />                                      </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-semibold text-red-500 mb-1 block">Address</label>
                                        <textarea name="FreightLocationAddress" value={formData.FreightLocationAddress} onChange={handleInputChange} rows={3} className={`${inputClass} resize-none`} data-testid="field-pickup-address" />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Firms Code</label>
                                        <input type="text" name="FirmsCode" value={formData.FirmsCode} onChange={handleInputChange} className={inputClass} data-testid="field-it-port" />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400 mb-1 block">Delivery Instructions</label>
                                        <textarea name="DeliveryInstructions" value={formData.DeliveryInstructions} onChange={handleInputChange} rows={4} className={`${inputClass} resize-none`} data-testid="field-delivery-instructions" />
                                    </div>
                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Route</label>
                                        <input type="text" name="RouteDetails" value={formData.RouteDetails} onChange={handleInputChange} className={inputClass} data-testid="field-it-port" />
                                    </div>

                                    <div className="grid grid-cols-1  sm:grid-cols-[140px_1fr] items-start sm:items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400 mb-1 block">Cargo Description</label>
                                        <textarea name="CargoDescription" value={formData.CargoDescription} onChange={handleInputChange} rows={4} className={`${inputClass} resize-none`} data-testid="field-cargo-descrioption" />
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    )}
                </div>

                {/* Particulars Furnished by Shipper */}
                <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
                    <SectionHeader icon={User} title="Particulars Furnished by Shipper" color="bg-blue-500" section="particulars" />

                    {expandedSections.particulars && (
                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: 'auto', opacity: 1 }}
                            className="p-4 border-t border-slate-200 dark:border-slate-800"
                        >
                            {/* Options Row */}
                            <div className="flex flex-wrap items-center gap-6 mb-4 pb-4 border-b border-slate-200 dark:border-slate-700">
                                <span className="text-xs font-medium text-slate-600 dark:text-slate-400">Print Weight & Measurement on B/L</span>
                                <div className="flex items-center gap-4">
                                    {[
                                        { label: 'Both', value: 'B' },
                                        { label: 'Metric Only', value: 'M' },
                                        { label: 'English Only', value: 'E' }
                                    ].map((opt) => (
                                        <label key={opt.value} className="flex items-center gap-1.5 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="WeightPrintOption"
                                                value={opt.value}
                                                checked={formData.WeightPrintOption === opt.value}
                                                onChange={handleInputChange}
                                                className="text-blue-600 focus:ring-blue-500"
                                            />
                                            <span className="text-xs text-slate-700 dark:text-slate-300">
                                                {opt.label}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                                <Button variant="destructive">Import from B/L</Button>
                                <label className="flex items-center gap-1.5 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        name="SLAC"
                                        checked={formData.SLAC}
                                        onChange={handleInputChange}
                                        className="rounded border-slate-300 text-blue-600 focus:ring-blue-500"
                                        data-testid="checkbox-slac"
                                    />
                                    <span className="text-xs font-medium text-slate-700 dark:text-slate-300">SLAC</span>
                                </label>
                                <label className="flex items-center gap-1.5 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        name="DoNotAutoCalculate"
                                        checked={formData.DoNotAutoCalculate}
                                        onChange={handleInputChange}
                                        className="rounded border-slate-300 text-blue-600 focus:ring-blue-500"
                                        data-testid="checkbox-no-auto-calc"
                                    />
                                    <span className="text-xs text-slate-700 dark:text-slate-300">Do not auto calculate</span>
                                </label>
                            </div>

                            {/* Container Table */}
                            <div className="overflow-x-auto">
                                <table className="w-full text-xs" data-testid="particulars-table">
                                    <thead>
                                        <tr className="bg-emerald-600 text-white">
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">CONTAINER</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">CONT. TYPE</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">NO. OF PKG</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">CARGO DESCRIPTION</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">IT #</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">CN/CPRS #</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">PICKUP #</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">LAST FREE DAY</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">NET WEIGHT</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">GROSS WEIGHT</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">MEASUREMENT</th>
                                            <th className="px-2 py-2 text-center font-medium w-10">DEL</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {containers.map((container, index) => {
                                            if (container.IsDeleted) return null;
                                            return (
                                                <tr key={index} className="border-t border-slate-100 dark:border-slate-700 align-top">
                                                    <td className="px-2 py-2">
                                                        <div className="space-y-1">
                                                            <input type="text" placeholder="Container No." value={container.ContainerNumber} onChange={(e) => handleContainerChange(index, 'ContainerNumber', e.target.value)} className={`${inputClass} py-1.5 text-xs`} data-testid={`container-no-${index}`} />
                                                            <input type="text" placeholder="Seal No" value={container.SealNumber} onChange={(e) => handleContainerChange(index, 'SealNumber', e.target.value)} className={`${inputClass} py-1.5 text-xs`} />
                                                            <textarea placeholder="Marks No" value={container.MarksNo} onChange={(e) => handleContainerChange(index, 'MarksNo', e.target.value)} rows={2} className={`${inputClass} py-1.5 text-xs resize-none`} />
                                                        </div>
                                                    </td>
                                                    <td className="px-2 py-2">
                                                        {containerTypeList.length > 0 && <select
                                                            value={container?.ContTypeCode || ''}
                                                            onChange={(e) => {
                                                                handleContainerChange(index, 'ContTypeCode', e.target.value)
                                                                handleContainerChange(index, 'ContTypeName', e.target.options[e.target.selectedIndex].text)
                                                            }}
                                                            className={`${selectClass} py-1.5 text-xs`}
                                                            data-testid={`cont-type-code-${index}`}
                                                        >
                                                            <option value="">Select</option>
                                                            {
                                                                containerTypeList?.map((ct, key) => (
                                                                    <option key={key} value={ct.moveTypeId}>{ct.moveType}</option>
                                                                ))
                                                            }
                                                        </select>}
                                                    </td>
                                                    <td className="px-2 py-2">
                                                        <input type="text" value={container.NoPackage} onChange={(e) => handleContainerChange(index, 'NoPackage', e.target.value)} className={`${inputClass} py-1.5 text-xs w-16`} />
                                                        <select className={`${selectClass} py-1.5 text-xs mt-1`}
                                                            value={container?.PackageCode}
                                                            onChange={(e) => handleContainerChange(index, 'PackageCode', e.target.value)}
                                                        >
                                                            <option value="">SELECT</option>
                                                            <option value="CTNS">CTNS</option>
                                                            <option value="PKGS">PKGS</option>
                                                            <option value="PCS">PCS</option>
                                                            <option value="PLTS">PLTS</option>
                                                        </select>
                                                    </td>
                                                    <td className="px-2 py-2">
                                                        <textarea value={container.CargoDescription} onChange={(e) => handleContainerChange(index, 'CargoDescription', e.target.value)} rows={4} className={`${inputClass} py-1.5 text-xs resize-none min-w-[140px]`} />
                                                    </td>
                                                    <td className="px-2 py-2">
                                                        <input type="text" placeholder="IT No." value={container.ITNumber} onChange={(e) => handleContainerChange(index, 'ITNumber', e.target.value)} className={`${inputClass} py-1.5 text-xs`} />
                                                    </td>
                                                    <td className="px-2 py-2">
                                                        <input type="text" placeholder="CN/CPRS #" value={container.CNCPRSNumber} onChange={(e) => handleContainerChange(index, 'CNCPRSNumber', e.target.value)} className={`${inputClass} py-1.5 text-xs`} />
                                                    </td>
                                                    <td className="px-2 py-2">
                                                        <input type="text" placeholder="Pickup No." value={container.PickUpNumber} onChange={(e) => handleContainerChange(index, 'PickUpNumber', e.target.value)} className={`${inputClass} py-1.5 text-xs`} />
                                                    </td>
                                                    <td className="px-2 py-2">
                                                        {/* <input type="date" value={container.LastDate} onChange={(e) => handleContainerChange(index, 'LastDate', e.target.value)} className={`${inputClass} py-1.5 text-xs`} /> */}
                                                        <div>
                                                            <DateInputwithcal
                                                                onError={handleDateError}
                                                                label="Last free day"
                                                                name={`containerLastDate_${index}`}
                                                                value={container?.LastDate}
                                                                onChange={(fieldName, value) => {
                                                                    handleContainerChange(
                                                                        index,
                                                                        "LastDate",
                                                                        value === "" || value == null ? null : value
                                                                    );
                                                                }}
                                                                required={false}
                                                            />
                                                            {dateErrors[`containerLastDate_${index}`] && (
                                                                <p className="text-red-500 text-xs mt-1">Invalid date</p>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="px-2 py-2">
                                                        <div className="space-y-1">
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-10">Net Kgs</span>
                                                                <input type="text" value={container.NetKgs} onChange={(e) => handleContainerChange(index, 'NetKgs', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-10">Net LBS</span>
                                                                <input type="text" value={container.NetLbs} onChange={(e) => handleContainerChange(index, 'NetLbs', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-2 py-2">
                                                        <div className="space-y-1">
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-6">KGS</span>
                                                                <input type="text" value={container.KGS} onChange={(e) => handleContainerChange(index, 'KGS', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-6">LBS</span>
                                                                <input type="text" value={container.LBS} onChange={(e) => handleContainerChange(index, 'LBS', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-2 py-2">
                                                        <div className="space-y-1">
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-6">CBM</span>
                                                                <input type="text" value={container.CBM} onChange={(e) => handleContainerChange(index, 'CBM', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-6">CFT</span>
                                                                <input type="text" value={container.CFT} onChange={(e) => handleContainerChange(index, 'CFT', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-2 py-2 text-center">
                                                        <button type="button" onClick={() => removeContainer(container)} className="p-1.5 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-md transition-colors" disabled={containers.length === 1} data-testid={`delete-row-${index}`}>
                                                            <Trash2 className="w-4 h-4" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {/* Add More Row */}
                            <div className="flex justify-center mt-4 mb-4">
                                <button type="button" onClick={addContainer} className="px-5 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-md text-xs font-medium transition-colors flex items-center gap-1.5" data-testid="add-more-row-btn">
                                    <Plus className="w-3.5 h-3.5" /> Add More Row
                                </button>
                            </div>

                            {/* Totals */}

                            <div className="bg-gradient-to-br from-slate-50 to-white dark:from-slate-800/50 dark:to-slate-900 rounded-xl border border-slate-200 dark:border-slate-700 p-4">
                                <div className="flex items-center gap-2 mb-4">
                                    <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center">
                                        <Weight className="w-4 h-4 text-white" />
                                    </div>
                                    <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-200">Total Summary</h4>
                                </div>

                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Containers</p>
                                        <p className="text-lg font-bold text-slate-800 dark:text-slate-200">{(totals.totalContainers || 0).toFixed(3)}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Packages</p>
                                        <p className="text-lg font-bold text-slate-800 dark:text-slate-200">{(totals.totalPackages || 0).toFixed(3)}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Gross KGS</p>
                                        <p className="text-lg font-bold text-slate-800 dark:text-slate-200">{(totals.totalGrossKgs || 0).toFixed(3) || '0.00'}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Gross LBS</p>
                                        <p className="text-lg font-bold text-slate-800 dark:text-slate-200">{(totals.totalGrossLbs || 0).toFixed(3) || '0.00'}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Net KGS</p>
                                        <p className="text-lg font-bold text-emerald-600 dark:text-emerald-400">{(totals.totalNetWeightKgs || 0).toFixed(3) || '0.00'}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Net LBS</p>
                                        <p className="text-lg font-bold text-emerald-600 dark:text-emerald-400">{(totals.totalNetWeightLbs || 0).toFixed(3) || '0.00'}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">CBM</p>
                                        <p className="text-lg font-bold text-blue-600 dark:text-blue-400">{(totals.totalCbm || 0).toFixed(3) || '0.00'}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">CFT</p>
                                        <p className="text-lg font-bold text-blue-600 dark:text-blue-400">{(totals.totalCft || 0).toFixed(3) || '0.00'}</p>
                                    </div>
                                </div>
                            </div>

                        </motion.div>
                    )}

                </div>

                {/* Common Clause Section */}
                <div className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden mt-3">

                    <SectionHeader
                        icon={FileText}
                        title="Clause"
                        color="bg-cyan-500"
                        section="commonClause"
                    />

                    {expandedSections.commonClause && (
                        <div className="border-t border-slate-200 dark:border-slate-800">

                            {/* Header */}
                            <div className="grid grid-cols-12 gap-4 px-4 py-3 bg-slate-50 dark:bg-slate-800 sticky top-0 z-10">
                                <div className="col-span-1 text-center text-xs font-semibold uppercase text-slate-500">
                                    Apply
                                </div>
                                <div className="col-span-3 text-xs font-semibold uppercase text-slate-500">
                                    Clause Type
                                </div>
                                <div className="col-span-6 text-xs font-semibold uppercase text-slate-500">
                                    Clause Description
                                </div>
                                <div className="col-span-2 text-right text-xs font-semibold uppercase text-slate-500">
                                    Status
                                </div>
                            </div>

                            {/* Scrollable Body (4 rows height) */}
                            <div className="max-h-[240px] overflow-y-auto divide-y divide-slate-200 dark:divide-slate-700">

                                {clauses?.length > 0 ? (
                                    clauses.map((clause, index) => (
                                        <div
                                            key={`clause-${clause.ClauseTypeDescriptionID}-${index}`}
                                            className="grid grid-cols-12 gap-4 px-4 py-3 items-center hover:bg-slate-50 dark:hover:bg-slate-800 transition"
                                        >
                                            {/* Apply */}
                                            <div className="col-span-1 flex justify-center">
                                                <input
                                                    type="checkbox"
                                                    className="h-4 w-4 rounded border-slate-300 text-[#0072FF] focus:ring-[#0072FF]"
                                                    checked={clause.applied || false}
                                                    onChange={(e) =>
                                                        handleClauseChange(
                                                            clause.ClauseTypeDescriptionID,
                                                            'applied',
                                                            e.target.checked
                                                        )
                                                    }
                                                />
                                            </div>

                                            {/* Clause Type */}
                                            <div className="col-span-3 text-sm font-medium text-slate-800 dark:text-slate-100">
                                                {clause.ClauseType}
                                            </div>

                                            {/* Clause Description with Tooltip */}
                                            <div className="col-span-6 relative group">
                                                <p className="text-sm text-slate-600 dark:text-slate-400 truncate cursor-pointer">
                                                    {clause.ClauseDescription}
                                                </p>

                                                <div className="absolute left-0 top-full z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none group-hover:pointer-events-auto w-[420px] p-3 mt-1 text-sm text-white bg-slate-900 rounded-md shadow-lg whitespace-normal break-words">
                                                    {clause.ClauseDescription}
                                                </div>
                                            </div>

                                            {/* Status */}
                                            <div className="col-span-2 flex justify-end">
                                                <span
                                                    className={`px-3 py-1 rounded-full text-xs font-semibold
                                                                ${clause.applied
                                                            ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                                                            : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                                                        }`}
                                                >
                                                    {clause.applied ? 'Applied' : 'Not Applied'}
                                                </span>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="py-6 text-center text-sm text-slate-500">
                                        Loading clauses...
                                    </div>
                                )}
                            </div>

                        </div>
                    )}
                </div>

                {/* Save / Update Button */}
                <div className="p-3 bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-200 dark:border-slate-800 overflow-hidden hover:shadow-md dark:shadow-none dark:hover:shadow-[0_0_12px_rgba(59,130,246,0.25)] transition-shadow duration-200">
                    <div className="flex items-center justify-between">

                        {/* Left side (optional note) */}
                        <div className="text-sm text-slate-500 dark:text-slate-400">
                            <span className="text-red-500">*</span> Required fields must be filled
                        </div>

                        {/* Right side actions */}
                        <div className="flex items-center gap-1.5">

                            {/* Cancel */}
                            <button
                                // onClick={onBack}
                                onClick={() => navigate("/import-booking")}
                                className="inline-flex items-center gap-1.5 text-[12.5px] font-medium px-4 h-[40px] rounded-[9px] transition-all duration-150 text-slate-600 hover:bg-red-50"
                            >
                                <span className="w-[15px] h-[15px] [&>svg]:w-full [&>svg]:h-full">
                                    <X />
                                </span>
                                <span className="hidden sm:inline">Cancel</span>
                            </button>

                            {/* Print (only in edit mode) */}
                            {Number(formData?.BolID) > 0 && (
                                <button
                                    onClick={() =>
                                        window.open(`/delivery-order/print/${btoa(String(formData?.BolID ?? ""))}`)
                                    }
                                    className="inline-flex items-center gap-1.5 text-[12.5px] font-medium px-4 h-[40px] rounded-[9px] transition-all duration-150 bg-slate-100 text-slate-600 border border-slate-200 hover:bg-slate-200 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600 dark:hover:bg-slate-600"
                                >
                                    <span className="w-[15px] h-[15px] [&>svg]:w-full [&>svg]:h-full">
                                        <Printer />
                                    </span>
                                    <span className="hidden sm:inline">Print</span>
                                </button>
                            )}

                            {/* Divider */}
                            <div className="w-px h-6 bg-slate-200 mx-1" />

                            {/* Save / Update */}
                            <CelebrationButton
                                onClick={handleSubmit}
                                label="Save / Update"
                                isSuccess={isAnimate}
                                className="inline-flex items-center gap-1.5 text-[12.5px] font-medium px-4 h-[40px] rounded-[9px] transition-all duration-150 bg-emerald-500 text-white hover:bg-emerald-600 shadow-md hover:shadow-lg"
                                icon={
                                    <span className="w-[15px] h-[15px] [&>svg]:w-full [&>svg]:h-full">
                                        <Save />
                                    </span>
                                }
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default DeliveryOrderForm;
